/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { CLIENT_URLS } from '@/api/url';
import { isAxiosError } from 'axios';

export interface GetClientsResponse {
  current_page: number;
  total_page: number;
  clients: Client[];
}

export interface ClientParams {
  page: number;
  limit: number;
  keyword?: string;
  archived?: boolean;
}

export const apiGetClients = async (
  params: ClientParams
): Promise<ApiResponse<GetClientsResponse>> => {
  try {
    const response = await api.get<ApiResponse<GetClientsResponse>>(CLIENT_URLS.GET_ALL, {
      params
    });
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export const apiGetClient = async (clientId: string): Promise<ApiResponse<Client>> => {
  try {
    const response = await api.get<ApiResponse<Client>>(CLIENT_URLS.GET(clientId));
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface CreateClientPayload {
  name: string;
  industry: string;
}

export const apiCreateClient = async (
  payload: CreateClientPayload
): Promise<ApiResponse<Client>> => {
  try {
    const response = await api.post<ApiResponse<Client>>(CLIENT_URLS.CREATE, payload);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface UpdateClientPayload {
  name: string;
  industry: string;
}

export const apiUpdateClient = async (
  clientId: string,
  payload: UpdateClientPayload
): Promise<ApiResponse<void>> => {
  try {
    const response = await api.put<ApiResponse<void>>(CLIENT_URLS.UPDATE(clientId), payload);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};

export interface ArchiveClientPayload {
  archived: boolean;
}

export const apiArchiveClient = async (
  clientId: string,
  payload: ArchiveClientPayload
): Promise<ApiResponse<void>> => {
  try {
    const response = await api.post<ApiResponse<void>>(CLIENT_URLS.ARCHIVE(clientId), payload);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
